import { Button, Group, Stack } from '@mantine/core';

import { Select } from '@components';
import { SimulateTsdModalProps } from '@features/tsd/TSDList/CustomsSimulator/types';
import { useSimulateTsdPNLinkingResultFormInitializer } from './useSimulateTsdPNLinkingResultFormInitializer';

const PN_LINKING_RESULT_STATUS_OPTIONS = [
  { value: '04', label: '04 - Linked' },
  { value: '05', label: '05 - Not linked' },
];

export const SimulateTsdPNLinkingResult: React.FC<SimulateTsdModalProps> = ({ tsd, onHide, onSubmit }) => {
  const {
    form,
    onSubmit: onSubmitForm,
    submitting,
  } = useSimulateTsdPNLinkingResultFormInitializer({
    tsd,
    onHide,
    onSubmit,
  });

  return (
    <form onSubmit={form.onSubmit(onSubmitForm)}>
      <Stack gap="sm" mb="xl">
        <Select {...form.getInputProps('status')} label="Status" placeholder="Select status" data={PN_LINKING_RESULT_STATUS_OPTIONS} allowDeselect={false} />
      </Stack>

      <Group justify="center">
        <Button type="button" onClick={onHide} disabled={submitting} size="lg" variant="transparent">
          Cancel
        </Button>

        <Button type="submit" loading={submitting} variant="filled" size="lg" data-pw="simulate-iets030-btn">
          Trigger
        </Button>
      </Group>
    </form>
  );
};
